import config from '../../../config';
import localStorage from 'localstorage-ttl';
import deploymentTemplates from './ProductTemplate.APP_ENV.ajs?preParser=retrieveProductTemplate'

const TEMPLATE_KEY = 'apTemplateList';
const CACHE_TIME_IN_MS = 1000*60*60*2 // cache for 2 hours

const cacheTemplates = () => {
    try {
        $.get(`${config.apiBase}/preview`)
        .then(function(response){
            localStorage.set(TEMPLATE_KEY, {data:response}, CACHE_TIME_IN_MS)
        }).catch(function(e){
            console.log(e);
        })
    } catch (error) {
        
    }
}

var ProductTemplate = localStorage.get(TEMPLATE_KEY);

if (!ProductTemplate) {
    cacheTemplates();
    ProductTemplate = deploymentTemplates;
}

export default ProductTemplate;


// WEBPACK FOOTER //
// ./src/Common/ProductTemplate/ProductTemplate.js